import BlockingSpinnerOverlay from 'components/BlockingSpinnerOverlay';
import EmailField from 'components/fields/EmailField';
import PropTypes from 'prop-types';
import { Alert, Button, Form, FormGroup } from 'reactstrap';
import { reduxForm } from 'redux-form';
import { useContext } from 'react';
import HpaStoreContext from 'contexts/HpaStoreContext';
import { getCustomBrandingDetail } from '../../../helpers/customBranding';

const LinkingRegistrationForm = (props) => {
    const { handleSubmit, onSubmit, isLoading, initialValues, customBrandingDisplayName } = props;
    const context = useContext(HpaStoreContext);

    const RegistrationInstructionText = getCustomBrandingDetail(context, 'registrationInstructionText');

    return (
        <div>
            <h2 className="AuthWrapper__register__title">
                Let's see if you already have an hStream ID.
            </h2>

            {customBrandingDisplayName && customBrandingDisplayName?.value && (
                <div className="AuthWrapper__redirect">
                    to continue to {customBrandingDisplayName?.value}
                </div>
            )}

            {RegistrationInstructionText && RegistrationInstructionText.value && RegistrationInstructionText.value.trim() !== '' && (
                <div className="mt-4">
                    <Alert color="info">{RegistrationInstructionText.value}</Alert>
                </div>
            )}

            <Form
                className="AuthWrapper__register mt-3 position-relative"
                aria-busy={isLoading}
                onSubmit={handleSubmit((values) => {
                    const email = values?.email;
                    if (email) {
                        onSubmit({ username: email });
                    }
                })}
            >
                <BlockingSpinnerOverlay show={isLoading} ariaLabel="Loading..." />
                <EmailField
                    label="Enter your email"
                    name="email"
                    initialValue={initialValues.email}
                />
                <FormGroup>
                    <Button
                        block
                        color="primary"
                        disabled={isLoading}
                        type="submit"
                    >
                        Continue
                    </Button>
                </FormGroup>
            </Form >
        </div>
    );
};

LinkingRegistrationForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    customBrandingDisplayName: PropTypes.object,
};

LinkingRegistrationForm.defaultProps = {
    isLoading: false,
    customBrandingDisplayName: null,
};

const ConnectedLinkingRegistrationForm = reduxForm({
    form: 'linking-registration',
})(LinkingRegistrationForm);

export default ConnectedLinkingRegistrationForm;
export { LinkingRegistrationForm as PureLinkingRegistrationForm };